module.exports = __webpack_public_path__ + "static/img/Jack_Gunston_mobile.985038a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Gunston_mobile.jpg
// module id = Szbj
// module chunks = 0